<template>
    <v-chip class="info-line" label style="padding: 0 5px; font-size: 16.25px" :color="$vuetify.theme.dark ? '#323338' : '#e3e3e3'">
        <span v-html="betInfoLine"></span>
    </v-chip>
</template>

<style scoped>
    .info-line {
        font-weight: 500;
    }
    .theme--light .info-line.v-chip {
        background-color: #f7f7f7 !important;
        border-color: #e3e3e3 !important;
        border-width: 1px !important;
        border-style: solid !important;
    }

    .theme--light .info-line.v-chip:before {
        background-color: #f7f7f7;
    }

    .theme--dark .info-line.v-chip {
        background-color: #323338 !important;
    }

    .theme--dark .info-line.v-chip:before {
        background-color: #323338;
    }
</style>

<script>
    import store from '~/store';

    export default {
        name: 'BetDialogInfo',
        props: {
            id: {
                default: '0',
                type: String,
            },
            module: undefined,
            odds: {
                default: undefined,
                type: String,
            },
        },

        computed: {
            betInfoLine() {
                let betInfoLine = '';
                let teamClass = '';

                if (this.betFeedData[this.id].betSelectionId === this.$const.BET_SELECTION_TEAM_ONE) {
                    teamClass =
                        this.betFeedData[this.id].market.handicap == 0.0
                            ? 'dogTeam'
                            : this.betFeedData[this.id].market.jw === this.$const.TEAM_HOME
                            ? 'jollywhereTeam'
                            : 'dogTeam';

                    betInfoLine =
                        '<div style="max-width: 230px;float: left;" class="text-truncate ' + teamClass + '">' + this.betFeedData[this.id].team + '&nbsp;</div>';
                } else if (this.betFeedData[this.id].betSelectionId === this.$const.BET_SELECTION_TEAM_TWO) {
                    teamClass =
                        this.betFeedData[this.id].market.handicap == 0.0
                            ? 'dogTeam'
                            : this.betFeedData[this.id].market.jw === this.$const.TEAM_AWAY
                            ? 'jollywhereTeam'
                            : 'dogTeam';

                    betInfoLine =
                        '<div style="max-width: 230px;float: left;" class="text-truncate ' + teamClass + '">' + this.betFeedData[this.id].team + '&nbsp;</div>';
                } else if (this.betFeedData[this.id].betSelectionId === this.$const.BET_SELECTION_TEAM_OVER) {
                    betInfoLine = store.$i18n.t('betDialog.over') + '&nbsp;' + this.betFeedData[this.id].market.handicap + '&nbsp;';
                } else if (this.betFeedData[this.id].betSelectionId === this.$const.BET_SELECTION_TEAM_UNDER) {
                    betInfoLine = store.$i18n.t('betDialog.under') + '&nbsp;' + this.betFeedData[this.id].market.handicap + '&nbsp;';
                } else if (this.betFeedData[this.id].betSelectionId === this.$const.BET_SELECTION_CORNERS_TEAM_OVER) {
                    betInfoLine = store.$i18n.t('betDialog.cornersOver') + '&nbsp;' + this.betFeedData[this.id].market.handicap + '&nbsp;';
                } else if (this.betFeedData[this.id].betSelectionId === this.$const.BET_SELECTION_CORNERS_TEAM_UNDER) {
                    betInfoLine = store.$i18n.t('betDialog.cornersUnder') + '&nbsp;' + this.betFeedData[this.id].market.handicap + '&nbsp;';
                }else if (this.betFeedData[this.id].betSelectionId === this.$const.BET_SELECTION_TEAM_X) {
                    betInfoLine = store.$i18n.t('betDialog.draw') + '&nbsp;';
                } else if (this.betFeedData[this.id].betSelectionId === this.$const.BET_SELECTION_TEAM_HOME ||
                    this.betFeedData[this.id].betSelectionId === this.$const.BET_SELECTION_CORNERS_TEAM_HOME) {
                    let handicap = '';
                    if (this.betFeedData[this.id].market.handicap == 0) {
                        handicap = this.betFeedData[this.id].market.handicap;
                    } else if (this.betFeedData[this.id].market.jw === this.$const.TEAM_HOME) {
                        handicap = '-' + this.betFeedData[this.id].market.handicap;
                    } else {
                        handicap = '+' + this.betFeedData[this.id].market.handicap;
                    }

                    teamClass =
                        this.betFeedData[this.id].market.handicap == 0.0
                            ? 'dogTeam'
                            : this.betFeedData[this.id].market.jw === this.$const.TEAM_HOME
                            ? 'jollywhereTeam'
                            : 'dogTeam';

                    betInfoLine =
                        '<div style="max-width: 230px;float: left;" class="text-truncate ' +
                        teamClass +
                        '">' +
                        this.betFeedData[this.id].team +
                        '&nbsp;</div>' +
                        handicap +
                        '&nbsp;';
                } else if (this.betFeedData[this.id].betSelectionId === this.$const.BET_SELECTION_TEAM_AWAY ||
                    this.betFeedData[this.id].betSelectionId === this.$const.BET_SELECTION_CORNERS_TEAM_AWAY) {
                    let handicap = '';
                    if (this.betFeedData[this.id].market.handicap == 0) {
                        handicap = this.betFeedData[this.id].market.handicap;
                    } else if (this.betFeedData[this.id].market.jw === this.$const.TEAM_AWAY) {
                        handicap = '-' + this.betFeedData[this.id].market.handicap;
                    } else {
                        handicap = '+' + this.betFeedData[this.id].market.handicap;
                    }
                    teamClass =
                        this.betFeedData[this.id].market.handicap == 0.0
                            ? 'dogTeam'
                            : this.betFeedData[this.id].market.jw === this.$const.TEAM_AWAY
                            ? 'jollywhereTeam'
                            : 'dogTeam';
                    betInfoLine =
                        '<div style="max-width: 230px;float: left;" class="text-truncate ' +
                        teamClass +
                        '">' +
                        this.betFeedData[this.id].team +
                        '&nbsp;</div>' +
                        handicap +
                        '&nbsp;';
                } else if (this.betFeedData[this.id].betSelectionId === this.$const.BET_SELECTION_YES) {
                    betInfoLine = store.$i18n.t('betDialog.btts') + ' - ' + store.$i18n.t('betDialog.yes') + '&nbsp;';
                } else if (this.betFeedData[this.id].betSelectionId === this.$const.BET_SELECTION_NO) {
                    betInfoLine = store.$i18n.t('betDialog.btts') + ' - ' + store.$i18n.t('betDialog.no') + '&nbsp;';
                } else if (this.betFeedData[this.id].betSelectionId === this.$const.BET_SELECTION_TEAM_1X) {
                    betInfoLine = store.$i18n.t('betDialog.home') + store.$i18n.t('betDialog.or') + store.$i18n.t('betDialog.draw') + '&nbsp;';
                } else if (this.betFeedData[this.id].betSelectionId === this.$const.BET_SELECTION_TEAM_12) {
                    betInfoLine = store.$i18n.t('betDialog.home') + store.$i18n.t('betDialog.or') + store.$i18n.t('betDialog.away') + '&nbsp;';
                } else if (this.betFeedData[this.id].betSelectionId === this.$const.BET_SELECTION_TEAM_X2) {
                    betInfoLine = store.$i18n.t('betDialog.draw') + store.$i18n.t('betDialog.or') + store.$i18n.t('betDialog.away') + '&nbsp;';
                } else if (this.betFeedData[this.id].betSelectionId === this.$const.BET_SELECTION_CS) {
                    betInfoLine = store.$i18n.t('betDialog.correctScore') + ' ' + this.betFeedData[this.id].correctScore + '&nbsp;';
                }

                if (this.betFeedData[this.id].marketId === this.$const.DBALL_MARKET_LIVE &&
                    (
                        this.betFeedData[this.id].betSelectionId === this.$const.BET_SELECTION_CORNERS_TEAM_HOME || this.betFeedData[this.id].betSelectionId === this.$const.BET_SELECTION_CORNERS_TEAM_AWAY ||
                        this.betFeedData[this.id].betSelectionId === this.$const.BET_SELECTION_CORNERS_TEAM_OVER || this.betFeedData[this.id].betSelectionId === this.$const.BET_SELECTION_CORNERS_TEAM_UNDER
                    )
                ) {
                    betInfoLine += '(' + (this.betFeedData[this.id].corners ? this.betFeedData[this.id].corners : this.$t('bet.NC')) + ')&nbsp;';
                } else if (this.betFeedData[this.id].marketId === this.$const.DBALL_MARKET_LIVE) {
                    betInfoLine += '(' + (this.betFeedData[this.id].sc ? this.betFeedData[this.id].sc : this.$t('bet.NC')) + ')&nbsp;';
                }

                betInfoLine += '@' + (this.odds ? parseFloat(this.odds).toFixed(3) : '');

                return betInfoLine;
            },
            user() {
                return this.$store.getters['UserModule/getUser'];
            },
            betFeedData: {
                get() {
                    return this.$store.getters[this.module + '/getBetFeedData'];
                },
                set(value) {
                    this.$store.commit(this.module + '/setBetFeedData', value);
                },
            },
        },
    };
</script>
